<template>
  <div
    class="product-seobrand"
    :id="id"
  >
    <accordion
      ref="accordion"
      class="product-seobrand__accordion"
      :is-content-html="true"
      :id="id"
      :name="$t('ads.main.brandSeo.headline',[brandName])"
    >
      <div class="product-seobrand__content | html-teaser">
        <div
          v-html="brandHtmlText"
        />
        <a
          :href="brandLink"
        >
          {{ $t('ads.main.brandSeo.link', [brandName]) }}
        </a>
      </div>
    </accordion>
  </div>
</template>

<script>
  import productPageStateComputedMixin
    from '../../utilities/vueMixins/productPageStateComputedMixin/productPageStateComputedMixin.js';
  import Accordion from '../accordion/accordion.vue';

  export default {
    components: {
      Accordion
    },
    mixins: [
      productPageStateComputedMixin
    ],
    props: {
      id: String,
    },
    computed: {
      brandHtmlText() {
        return this.productDetails.product.brand.htmlText;
      },
      brandLink() {
        return this.productDetails.product.brand.link;
      },
      brandName() {
        return this.productDetails.product.brand.name;
      }
    },
    methods: {
      openAccordion() {
        this.$refs.accordion.open();
      }
    }
  };

</script>
